import { render, staticRenderFns } from "./student-card.vue?vue&type=template&id=c1da83b4"
import script from "./student-card.vue?vue&type=script&lang=js"
export * from "./student-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports